import * as React from "react";
import { css } from "@emotion/core";
import { ProgressBar } from "@blueprintjs/core";
import { ScrollView } from "components/common/";

export const SingleFile = ({ name, speed, progress, seconds }) => {
  if (!seconds) return null;

  return (
    <>
      <div
        css={css`
          display: flex;
          align-items: center;
          padding: 0.5rem 1rem;
          color: var(--neutral-3);
        `}
      >
        <div
          css={css`
            margin-right: 1rem;
          `}
        >
          {name}
        </div>
        <ProgressBar
          css={css`
            flex-grow: 1;
            margin-right: 1rem;
          `}
          intent="success"
          value={progress}
        />
        <div
          css={css`
            margin-right: 1rem;
            width: 2rem;
          `}
        >
          {Math.round(progress * 100)}%
        </div>
        <div
          css={css`
            width: 200px;
            text-align: right;
          `}
        >
          <div
            css={css`
              font-size: 0.8rem;
            `}
          >
            {speed}/sec
          </div>
        </div>
      </div>
    </>
  );
};

export const AllFiles = ({ complete, total }) => {
  return (
    <div
      css={css`
        display: flex;
        padding: 0 1rem;
        align-items: center;
        margin: 1rem 0;
      `}
    >
      <div
        css={css`
          margin-right: 2rem;
          font-weight: 700;
          font-size: 1.2rem;
        `}
      >
        All Images
      </div>
      <div
        css={css`
          flex-grow: 1;
          margin-right: 2rem;
        `}
      >
        <ProgressBar intent="success" value={complete / total} />
      </div>
      <div>
        {complete}/{total}
      </div>
    </div>
  );
};

const UploadProgress = ({
  images,
  progress,
  showAll = true,
  showSingle = true,
}) => {
  const files = React.useMemo(() => Object.entries(progress), [progress]);

  const inprogress = files.filter(
    ([key, file]) => file.progress > 0 && file.progress < 1
  );

  const allImages = Object.values(images);
  const allUploads = {
    complete: allImages.filter((image) => image.uploaded).length,
    total: allImages.length,
  };
  return (
    <>
      {showAll && <AllFiles {...allUploads} />}
      {showSingle && (
        <ScrollView>
          {inprogress.map(([key, file]) => {
            const image = images[key];
            return (
              <SingleFile
                key={image.name}
                name={image.name}
                speed={file.stats.readableSpeed}
                progress={file.progress || 0}
                seconds={file.stats.secondsLeft}
              />
            );
          })}
        </ScrollView>
      )}
    </>
  );
};

export default UploadProgress;
